import { AfterViewInit, Component, ElementRef, inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AlertController, IonicModule, IonInput, IonSearchbar, LoadingController, Platform } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { QRCodeComponent } from 'angularx-qrcode';
import { FlagIonic, ViewOptions } from '../services/drupal7/models';
import { EntityServiceCustom, EntitySetupOptions } from '../services/entity.service';
import { MessagesService } from '../services/messages.service';
import { FlagServiceCustom } from '../services/flag.service';
import { DelegateRegistrationRecordLocator } from '../services/drupal7/models/node-types';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { CodeScanService } from '../services/codescan.service';
import jsQR from 'jsqr';
import { StorageService } from '../services/storage.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule, QRCodeComponent],
  encapsulation: ViewEncapsulation.None
})
export class TicketsComponent implements OnInit, AfterViewInit {

  router = inject(Router);
  route = inject(ActivatedRoute);
  flag = inject(FlagServiceCustom);
  alertCtrl = inject(AlertController);
  platform = inject(Platform);
  loadingCtrl = inject(LoadingController);
  barcodeScanner = inject(BarcodeScanner);
  codeScan = inject(CodeScanService);
  entity = inject(EntityServiceCustom);
  storage = inject(StorageService);
  message = inject(MessagesService);

  @ViewChild('searchInput', {static: false}) searchInput: IonSearchbar;
  @ViewChild('scannedInputField', {static: false}) scannedInputField: IonInput;
  @ViewChild('video', {static: false}) video: ElementRef;
  @ViewChild('canvas', {static: false}) canvas: ElementRef;

  scanActive = false;
  localStream: any;

  videoElement: any;
  canvasElement: any;
  canvasContext: any;

  loading: HTMLIonLoadingElement;

  data: DelegateRegistrationRecordLocator[] = [];

  noResultsData = true;
  inputData: string | number;
  scannedInput: string | number;
  editObj = {};

  cardBadge = false;

  constructor() {}

   async ngOnInit() {
   }

   ngAfterViewInit() {
    this.videoElement = this.video.nativeElement;
    this.canvasElement = this.canvas.nativeElement;
    this.canvasContext = this.canvasElement.getContext('2d');
    this.storage.get('stored_records').then(records => {
      if (records) {
        for (const record of records) {
          this.find(record.nid, record.lastName, record.order, true, 'Loading records...');
        }
      }
    });
    const ticketId = this.route.snapshot.queryParamMap.get('id');
    const orderId = this.route.snapshot.queryParamMap.get('order_id');
    if (ticketId && orderId) {
      this.find(+ticketId, '', +orderId);
      this.router.navigate([], {queryParams: {}, queryParamsHandling: 'merge', replaceUrl: true});
    }
   }

   async startScan() {
    this.localStream = await navigator.mediaDevices.getUserMedia({
      video: {facingMode: 'environment'}
    });
    this.videoElement.srcObject = this.localStream;
    this.videoElement.setAttribute('playsinline', true);
    this.videoElement.play();
    this.loading = await this.loadingCtrl.create({});
    await this.loading.present();
    requestAnimationFrame(this.scan.bind(this));
   }

   async scan() {
    if (this.videoElement.readyState === this.videoElement.HAVE_ENOUGH_DATA) {
      if (this.loading) {
        await this.loading.dismiss();
        this.loading = null;
        this.scanActive = true;
      }

      this.canvasElement.height = this.videoElement.videoHeight;
      this.canvasElement.width = this.videoElement.videoWidth;
      this.canvasContext.drawImage(
        this.videoElement,
        0,
        0,
        this.canvasElement.width,
        this.canvasElement.height
      );
      const imageData = this.canvasContext.getImageData(
        0,
        0,
        this.canvasElement.width,
        this.canvasElement.height
      );
      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: 'dontInvert'
      });
      if (code) {
        this.scanActive = false;
        this.message.showLoading('Searching...', false, 1500);
        const res = await this.codeScan.parseScan(code.data);
        if (res.id && res.order_id) {
          this.find(res.id, '', res.order_id);
        } else {
          this.message.presentAlert('Invalid Scan', 'The scanned code is invalid.');
        }
        this.stopScan();
      } else {
        if (this.scanActive) {
          requestAnimationFrame(this.scan.bind(this));
        }
      }
    } else {
      requestAnimationFrame(this.scan.bind(this));
    }
   }
  
   async stopScan() {
    this.scanActive = false;
    this.localStream.getTracks().forEach(track => track.stop());
  }

  async find(nid: number, lastName: string, order: number = 0, showLoading: boolean = true, loadingTitle: string = 'Searching...') {
    if (!nid) {
      return;
    }
    const options: ViewOptions = {
      display_id: 'app_my_delegate',
      filters: {
        nid,
      }
    };
    if (order > 0) {
      options.filters.order_id = order;
    }
    if (lastName) {
      options.filters.contact_last_name_value = lastName;
    }
    if (showLoading) {
      this.message.showLoading(loadingTitle, false, 2000);
    }
    const setupOptions: EntitySetupOptions = {
      qrCodes: true,
      badgeType: true
    };
    const record = await this.entity.getViewWithOptions('record-locator', options, setupOptions);
    if (record.results) {
      const storedRecords = await this.storage.get('stored_records');
      for (const result of record.results) {
        if (storedRecords) {
          const index = this.data.map((o) => o.nid).indexOf(+nid);
          if (index !== -1) {
            this.data[index] = result;
          } else {
            this.data.unshift(result);
          }
        } else {
          this.data.unshift(result);
        }
        this.storage.storeRecord(+nid, result.contact_last_name, order, this.setupFeedbackObject(result));
      }
      this.noResultsData = false;
    }
  }

  scanQRCode() {
    if (this.platform.is('capacitor')) {
      // document.querySelector('body').classList.add('scanner-active');
      // this.barcodeScanner();
      this.barcodeScanner.scan({showFlipCameraButton: true, preferFrontCamera: false}).then(async (barcodeData) => {
        if (barcodeData.text && !barcodeData.cancelled) {
          this.message.showLoading('Searching...', false, 1500);
          const res = await this.codeScan.parseScan(barcodeData.text);
          this.find(res.id, '', res.order_id);
        }
       }).catch(() => {
       });
    } else {
      this.startScan();
      // this.scannedInput = '';
      // this.scannedInputField.setFocus();
    }
  }

  // async barcodeScanner() {
  //   await BarcodeScanner.checkPermission({ force: true });
  //   BarcodeScanner.hideBackground();
  //   const barcodeData = await BarcodeScanner.startScan();
  //   if (barcodeData.hasContent) {
  //     document.querySelector('body').classList.remove('scanner-active');
  //     this.message.showLoading('Searching...', false, 1500);
  //     const res = await this.codeScan.parseScan(barcodeData.content);
  //     this.find(res.id, res.order_id);
  //   }
  // };

  async recordLocator() {
    const alert = await this.alertCtrl.create({
      header: 'Locate your registration',
      inputs: [{
          name: 'nid',
          type: 'tel',
          id: 'nid',
          placeholder: 'Delegate ID'
      }, {
          name: 'last_name',
          type: 'text',
          id: 'last_name',
          placeholder: 'Last Name'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'danger',
        },
        {
          text: 'Search',
          role: 'submit',
          cssClass: 'primary',
        }
      ]
    });
    await alert.present();
    return await alert.onDidDismiss().then(async (res: any) => {
      if (res.role !== 'cancel') {
        this.find(res.data.values.nid, res.data.values.last_name);
      }
    }, () => {
      return this.message.presentAlert('No results found', 'No results found. Please check that you have entered the correct information.')
    });
  }

  async refresh(data: DelegateRegistrationRecordLocator, i: number) {
    this.find(data.nid, data.contact_last_name, data.order_id);
  }

  setupFeedbackObject(data: DelegateRegistrationRecordLocator) {
    const feedbackData = {
      first_name: data.contact_first_name.trim(),
      last_name: data.contact_last_name.trim(),
      email: data.contact_email,
      phone_number: data.contact_phone_number,
      type: data.delegate_type_value,
      nid: data.nid,
    }
    return feedbackData;
  }

  async flagEntity(item: any, flag: FlagIonic, flagValue: boolean) {
    flag.name = 'flag_checked_in'
    flag.label = 'Conference Check-in';

    const flagMessage = 'Flagged ' + flag.label + ' for ' + item.contact_first_name + ' ' + item.contact_last_name;
    const unflagMessage = 'Unflagged ' + flag.label + ' for ' + item.contact_first_name + ' ' + item.contact_last_name;
    const newFlagStatus = await this.flag.flagEntity(item, flag, flagValue, {user: {uid: 1844}}, flagMessage, unflagMessage, '', true, true);
    item['flag_'+flag.name] = newFlagStatus;
}

  remove(nid: number, i: number) {
    this.data.splice(i, 1);
    this.storage.deleteRecord(nid);
  }

  doRefresh(event: any) {
    this.storage.get('stored_records').then(records => {
      if (records) {
        for (const record of records) {
          this.find(record.nid, record.lastName, record.order, true, 'Loading records...');
        }
      } else {
        this.data = [];
      }
    });
    setTimeout(() => {
      event.target.complete();
    }, 2000);
  }



}
